/**
 * The Amplitude device id of this visitor, once the real SDK is in.
 *
 * The SDK loads after the consent answer (`src/cookie/consent.ts`); until
 * then `window.amplitude` is the command queue, which has no
 * `getDeviceId`. An experiment buckets by this id so its exposure and the
 * visitor's later events meet in one Amplitude user — any other id would
 * split them. `undefined` when the SDK never arrives (blocked, offline,
 * outside production) within `timeoutMs`. Never throws.
 */
export function waitForAmplitudeDeviceId(
  timeoutMs = 5_000,
  pollMs = 200,
): Promise<string | undefined> {
  const read = (): string | undefined => {
    try {
      const id = window.amplitude?.getDeviceId?.()
      return typeof id === 'string' && id !== '' ? id : undefined
    } catch {
      return undefined
    }
  }
  return new Promise((resolve) => {
    const now = read()
    if (now) {
      resolve(now)
      return
    }
    const started = Date.now()
    const timer = setInterval(() => {
      const id = read()
      if (id || Date.now() - started >= timeoutMs) {
        clearInterval(timer)
        resolve(id)
      }
    }, pollMs)
  })
}
